// Style
import './App.css';

// Packages
import { Route, Switch } from 'react-router-dom';

// Components
import Finder from './components/Finder/Finder';
import Editor from './components/Editor/Editor';
import Dashboard from './components/Dashboard/Dashboard';
import BucketView from './components/BucketView/BucketView';
import Header from './components/Header/Header';
import useAccessToken from './hooks/useAccessToken';

// Global Hooks for lifted state
import { useIsAuthenticated } from '@azure/msal-react';
import FileView from './components/FileView/FileView';
import View from './components/FileView/View';

export default function App() {
  const isAuthenticated = useIsAuthenticated();

  const accessToken = useAccessToken();

  if (isAuthenticated && accessToken) {
    return (
      <Switch>
        <Route exact path='/' component={Finder}></Route>
        <Route exact path='/edit/:systemID' component={Editor}></Route>
        <Route exact path='/dashboard' component={Dashboard}></Route>
        <Route exact path='/bucketview' component={BucketView}></Route>
        <Route path='/view' component={View} />
        <Route exact path='/fileview' component={FileView}></Route>
      </Switch>
    );
  }
  return (
    <div className='unauthorized-message'>
      <Header />
      <center>
        <br /> <br />
        <h2>To access the NLD Refinement Web Application please sign in.</h2>
      </center>
    </div>
  );
}
